import dynamic from 'next/dynamic';

export const Scales = dynamic(() => import('./Scales'), { ssr: false });
export const ColorLegend = dynamic(() => import('./ColorLegend'), {
  ssr: false,
});
